import { useMutation, useQueryClient } from '@tanstack/react-query';
import fetchApi from './fetchApi';

interface DeleteBookingVariables {
  id: number;
}

interface DeleteBookingResponse {
  success: true;
}

const useDeleteBookingMutation = () => {
  const client = useQueryClient();
  return useMutation({
    mutationKey: ['delete-booking'],
    mutationFn: (data: DeleteBookingVariables) =>
      fetchApi<DeleteBookingResponse>(`/api/bookings/${data.id}`, {
        method: 'DELETE',
      }),
    onSuccess: (_: DeleteBookingResponse, variables: DeleteBookingVariables) => {
      client.setQueriesData<Odoo.Booking[]>({ queryKey: ['bookings'] }, oldData => {
        if (!oldData) return [];
        return oldData.filter(booking => booking.id !== variables.id);
      });
    },
  });
};

export default useDeleteBookingMutation;
